import type { Logger } from '@mimir/common/types/logger';
import { type Observable, ObservableState } from '@mimir/common/util/observable';
import type { PeakRange } from './audioTrackConfig';
import type { PeaksManagerOps } from './peaksManagerOps';
import type { ItemPollingOps } from '@mimir/client-common/polling/itemPollingOps';
import { loadPeaks, type PeaksFromM4aProxiesConfig } from '../pages/cutter/loadPeaks';
import type { AudioInitializationCallbacks } from './itemMediaPlayerOps';

export class StandalonePeaksManager {

  private peakCount = new ObservableState<number>(0);
  private peaksManager : PeaksManagerOps | null = null;

  private pollingListenerId: string | null = null;

  constructor(
    private services: {
      logger: Logger,
      itemPollingOps: ItemPollingOps,
    }
  ) { }

  loadItem(itemId: string, callbacks: AudioInitializationCallbacks) {
    this.clear();
    const setPeaksManager = (peaksManager: PeaksManagerOps) => this.peaksManager = peaksManager;
    const peaksFromM4aProxiesConfig: PeaksFromM4aProxiesConfig = {
      cumulatedAudioProxyDurationInMs: new ObservableState(0),
      markAudioProxiesTooLargeToLoad: () => {
        callbacks.onError('Audio proxies too large');
      }
    };
    loadPeaks(
      itemId, this.services.itemPollingOps, id => this.pollingListenerId = id,
      setPeaksManager, peaksFromM4aProxiesConfig, this.peakCount,
      callbacks,
    );
  }

  getPeakSeriesCount(_trackIndex: number): number {
    return 1;
  }

  /**
   * Given an audio track index, the index of one of the track's channels,
   * a viewport width in pixels and a range within the source media duration
   * range return the peaks to draw for a visualization of peaks
   */
  getPeaksForSourceMediaRange(
    trackIndex: number,
    width: number,
    _channel: number,
    range: PeakRange
  ): number[] {

    if (this.peaksManager !== null) {
      return this.peaksManager.getPeaks(trackIndex, _channel, range, width);
    }

    return Array(width).fill(0);
  }

  getPeakCountObs(): Observable<number> {
    return this.peakCount.getObservable();
  }

  public clear(): void {
    if (this.pollingListenerId !== null) {
      this.services.itemPollingOps.removePollListener(this.pollingListenerId);
      this.pollingListenerId = null;
    }
    this.peaksManager = null;
    this.peakCount.value = 0;
  }
}
